import React, { createContext, useContext, useReducer } from 'react';

export interface TrayState {
  isOpen: boolean;
  width: number;
}

type TrayMap = Record<string, TrayState>;

type Action =
  | { type: 'INIT'; id: string; state: TrayState }
  | { type: 'SET_OPEN'; id: string; isOpen: boolean }
  | { type: 'SET_WIDTH'; id: string; width: number };

function trayReducer(state: TrayMap, action: Action): TrayMap {
  switch (action.type) {
    case 'INIT':
      if (state[action.id] !== undefined) return state;
      return { ...state, [action.id]: action.state };
    case 'SET_OPEN':
      if (!state[action.id]) return state;
      return { ...state, [action.id]: { ...state[action.id], isOpen: action.isOpen } };
    case 'SET_WIDTH':
      if (!state[action.id]) return state;
      return { ...state, [action.id]: { ...state[action.id], width: action.width } };
    default:
      return state;
  }
}

export interface TrayContextValue {
  map: TrayMap;
  dispatch: React.Dispatch<Action>;
}

export const TrayContext = createContext<TrayContextValue>({
  map: {},
  dispatch: () => {},
});

export const TrayProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [map, dispatch] = useReducer(trayReducer, {});
  return (
    <TrayContext.Provider value={{ map, dispatch }}>
      {children}
    </TrayContext.Provider>
  );
};
